const initialState = {
  user: null,
  userDbInfo: null,
  userChartInfo: null,
  userSweepInfo: null,
};

const reducer = (state = initialState, action) => {
  let newState = { ...state };

  switch (action.type) {
    case "SET_USER":
      newState = {
        ...state,
        user: action.value,
      }
      break;
    case "SET_USER_DB_INFO":
      newState = {
        ...state,
        userDbInfo: action.value,
      }
      break;
    case "SET_USER_CHART_INFO":
      newState = {
        ...state,
        userChartInfo: action.value,
      }
      break;
    case "SET_USER_SWEEP_INFO":
      newState = {
        ...state,
        userSweepInfo: action.value,
      }
      break;
    case "ERROR_ON_USER":
      newState = {
        ...state,
      }
      console.log('error on user');
      break;

    default:
  }
  return newState;
};

export default reducer;
